import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config'; // Seu appConfig com Router e HttpClient
import { AppComponent } from './app/app.component';



bootstrapApplication(AppComponent, appConfig) 
  .catch((err) => console.error(err));